import axios from "axios";
import router from "../../router";

export default {
  namespaced: true,
  state: {
    accessToken: null,
    refreshToken: null,
  },
  getters: {
    isAuthenticated: (state) => !!state.accessToken,
    accessToken: (state) => state.accessToken,
    refreshToken: (state) => state.refreshToken,
  },
  mutations: {
    setTokens(state, { accessToken, refreshToken }) {
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
    },
    clearTokens(state) {
      state.accessToken = null;
      state.refreshToken = null;
    },
  },
  actions: {
    async login({ commit, dispatch }, { email, password }) {
      try {
        const { data } = await axios.post(
          "/api/enduser/login",
          {
            email: email.trim(),
            password,
          },
          { noAuth: true },
        );

        if (data && data.status) {
          commit("setTokens", {
            accessToken: data.access_token,
            refreshToken: data.refresh_token,
          });

          await dispatch("user/fetchUser", null, { root: true });

          return data;
        } else {
          throw new Error(data.message || "Нэвтрэхэд алдаа гарлаа");
        }
      } catch (error) {
        console.error("Login Error:", error);
        throw error;
      }
    },
    logout({ commit, state }) {
      const { accessToken, refreshToken } = state;
      if (accessToken && refreshToken) {
        axios
          .post(
            "/api/enduser/logout",
            { refresh_token: refreshToken },
            {
              headers: { Authorization: `Bearer ${accessToken}` },
              noAuth: true,
            },
          )
          .catch(() => {});
      }
      commit("clearTokens");
      commit("user/SET_USER", null, { root: true });
      router.push("/user/login");
    },
  },
};
